import React from 'react'

import { useIsAuthed } from './AuthShieldContext'

interface IAuthShieldHideProps {
  hideAuthed?: boolean
  hideUnauthed?: boolean
  children: JSX.Element | React.ReactNode
}

const AuthShieldHide = ({ hideAuthed = false, hideUnauthed = false, children }: IAuthShieldHideProps) => {
  const isAuthed = useIsAuthed()
  const hide = isAuthed ? hideAuthed : hideUnauthed
  return hide ? null : <>{children}</>
}

export default AuthShieldHide
